<h3 mat-dialog-title>Bel opties</h3>

<div mat-dialog-content class="dialog-body">
  <div class="section">
    <div class="section-title">Hoe vaak?</div>

    <div class="toggle-row">
      @for (t of timesOptions; track t) {
      <button mat-stroked-button [color]="selectedTimes === t ? 'primary' : undefined" (click)="setTimes(t)">
        {{ t }}x
      </button>
      }
    </div>
  </div>

  <div class="section">
    <div class="section-title">Hoe sterk?</div>

    <div class="toggle-row">
      @for (s of strengthOptions; track s.value) {
      <button mat-stroked-button [color]="selectedStrength === s.value ? 'primary' : undefined"
        (click)="setStrength(s.value)">
        <mat-icon>{{ s.icon }}</mat-icon>
        <span class="ml-6">{{ s.label }}</span>
      </button>
      }
    </div>
  </div>

  @if (isRinging) {
  <div class="hint">Bezig met bellen… 🎉</div>
  }
</div>

<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Annuleren</button>
  <button mat-raised-button color="primary" (click)="ringNow()">
    <mat-icon>notifications_active</mat-icon>
    Bellen!
  </button>
</div>